export async function copyToClipboard(text: string): Promise<boolean> {
    /* ① 原生桥接（推荐，放最前） */
    if (window.AndroidApp && window.AndroidApp.copyText) {
        console.log('Copy to clipboard:', text);
        try {
            window.AndroidApp.copyText(text);
            return true;
        } catch (error) {
            console.error('Copy to clipboard failed:', error);
            return false;
        }
    }
  
    /* ② 标准 Clipboard API：仅在安全上下文可用 */
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (error) {
        console.error('Copy to clipboard failed:', error);
        return false;
      }
    }
  
    /* ③ 旧式 fallback：execCommand */
    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.cssText = 'position:fixed;left:-9999px;top:-9999px;';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      return true;
    } catch (error) {
      console.error('Copy to clipboard failed:', error);
      return false;
    }
  };